import qs from 'qs'
import service from "../libs/request.js";
//const prefix = ''
const prefix = '/printService'

/**
 * @description 材料类型
 */
const stuffType = [{
	label: 'SLA光敏树脂',
	value: '1'
}]

/**
 * @description 发货状态
 */
const deliveryStatus = [{
		label: '未打印',
		value: '0'
	},
	{
		label: '未发货',
		value: '1'
	},
	{
		label: '已发货',
		value: '2'
	},
	{
		label: '部分发货',
		value: '3'
	}
]

/**
 * @description 任务类型
 */
const taskType = [{
		label: '普通任务',
		value: '1'
	},
	{
		label: '分型主任务',
		value: '2'
	},
	{
		label: '分型子任务',
		value: '3'
	}
]

/**
 * @description /任务状态
 */
const taskStatus = [{
		label: '待估价和审核',
		value: '1',
		color: '#00C147'
	},
	{
		label: '估价完成待支付',
		value: '2',
		color: '#D8063C'
	},
	{
		label: '平台拒绝',
		value: '3',
		color: '#9F9F9F'
	},
	{
		label: '主动取消',
		value: '4',
		color: '#9F9F9F'
	},
	{
		label: '等待打印',
		value: '5',
		color: '#FFAE0B'
	},
	{
		label: '打印中',
		value: '6',
		color: '#FFAE0B'
	},
	{
		label: '打印完成待确认',
		value: '7',
		color: '#0B17FF'
	},
	{
		label: '发货完成',
		value: '8',
		color: '#9F9F9F'
	},
	{
		label: '取消并退款',
		value: '9',
		color: '#9F9F9F'
	},
	{
		label: '排期完成待打印',
		value: '10'
	},
	// {
	// 	label: '打印完成待审核',
	// 	value: '11'
	// },
	{
		label: '通过待发货',
		value: '12'
	},
	{
		label: '拒绝发货',
		value: '13'
	}
]

const findAddressList = (customerId, callback) => {
	service.get({
		url: `${prefix}/address/findAddressList?customerId=${customerId}`,
		loading: true,
		success: function(res) {
			callback(res);
		}
	});
};

const findAddressListPage = (current, size, customerId, callback) => {
	service.get({
		url: `${prefix}/address/findAddressListPage?customerId=${customerId}&size=${size}&current=${current}`,
		loading: true,
		success: function(res) {
			callback(res);
		}
	});
};

var addAddress = function(data, callback) {
	service.post({
		url: `${prefix}/address/addAddress`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var updateAddress = function(data, callback) {
	service.post({
		url: `${prefix}/address/updateAddress`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};


var deleteAddress = function(data, callback) {
	service.post({
		url: `${prefix}/address/deleteAddress`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var findRegionByCode = function(code, level, callback) {
	service.get({
		url: `${prefix}/address/findRegionByCode?code=${code}&level=${level}`,
		loading: true,
		success: function(res) {
			callback(res);
		}
	});
};

var submitTask = function(data, callback) {
	service.post({
		url: `${prefix}/printTask/submitTask`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var findTaskByUserId = function(params, callback) {
	service.get({
		url: `${prefix}/printTask/findTaskByUserId?customerId=${params.customerId}&size=${params.size}&current=${params.current}&startTime=${params.startTime}&endTime=${params.endTime}&status=${params.status}`,
		loading: true,
		success: function(res) {
			callback(res);
		}
	});
};

// 根据任务id查询给用户确认的图片list
var findCheckPicByTaskId = function(data, callback) {
	service.post({
		url: `${prefix}/printTask/findCheckPicByTaskId`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var cancelTask = function(data, callback) {
	service.post({
		url: `${prefix}/printTask/cancelTask`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var findLogisticsCompanyList = function(data, callback) {
	service.post({
		url: `${prefix}/printTask/findLogisticsCompanyList`,
		loading: true,
		success: function(res) {
			callback(res);
		}
	});
};

var taskPay = function(data, callback) {
	service.post({
		url: `${prefix}/3dPrintTaskPay/pay`,
		loading: true,
		data: data,
		success: function(res) {
			callback(res);
		}
	});
};

var findPayResult = function(taskId, callback) {
	service.get({
		url: `${prefix}/printTask/findPayResult?id=${taskId}`,
		loading: false,
		success(res) {
			callback(res);
		}
	});
};

var findTaskLogisticsDetailsList = function(taskId, callback) {
	service.get({
		url: `${prefix}/printTask/findTaskLogisticsDetailsList?id=${taskId}`,
		loading: false,
		success(res) {
			callback(res);
		}
	});
};

// var findCheckPicByTaskId = function(data, callback) {
// 	service.post({
// 		url: `${prefix}/printTask/findCheckPicByTaskId`,
// 		loading: true,
// 		data,
// 		success: function(res) {
// 			callback(res);
// 		}
// 	});
// };

var updateTaskStatusById = function(data, callback) {
	service.post({
		url: `${prefix}/printTask/updateTaskStatusById`,
		loading: true,
		data,
		success: function(res) {
			callback(res);
		}
	});
};

var findTaskConsignmentLogById = function(data, callback) {
	service.post({
		url: `${prefix}/taskConsignment/findTaskConsignmentLogById`,
		loading: true,
		data,
		success: function(res) {
			callback(res);
		}
	});
};

export default {
	findTaskConsignmentLogById,
	findCheckPicByTaskId,
	updateTaskStatusById,
	deliveryStatus,
	taskStatus,
	taskType,
	stuffType,
	findAddressList,
	findAddressListPage,
	addAddress,
	updateAddress,
	deleteAddress,
	findRegionByCode,
	findTaskByUserId,
	cancelTask,
	findLogisticsCompanyList,
	submitTask,
	taskPay,
	findPayResult,
	findTaskLogisticsDetailsList
};
